import faq from './faq';
export default function () {
  faq();
}

export {faq}
